import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-section" className="py-24 bg-brand-cream relative overflow-hidden" data-id="element-120">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-121">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-orange/5 rounded-full blur-3xl" data-id="element-122"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-123">
        <FadeIn data-id="element-124">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-16 text-center border-4 border-brand-orange/20 relative overflow-hidden" data-id="element-125">
            {/* Top accent line */}
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-orange via-brand-green to-brand-orange" data-id="element-126"></div>

            <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-127">
              Obtené el acceso inmediato a todo el sistema{' '}
              <br className="hidden md:block" data-id="element-128" />
              <span className="text-brand-orange" data-id="element-129">"Reset Metabólico 45+"</span>
            </h2>

            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-130">
              Una inversión única para dejar de adivinar y empezar a ver
              resultados reales en tu cuerpo.
            </p>

            <div className="mb-8" data-id="element-131">
              <span className="block text-gray-400 line-through text-lg mb-1" data-id="element-132">
                $17.800 ARS
              </span>
              <span className="block font-serif text-5xl md:text-6xl font-bold text-brand-orange" data-id="element-133">
                $8.900
              </span>
              <span className="block text-gray-500 text-base mt-1" data-id="element-134">
                ARS — Pago único
              </span>
            </div>

            <div className="mb-10" data-id="element-135">
              <CTAButton variant="checkout" className="w-full md:w-auto md:px-12 md:py-5 text-xl" data-id="element-136" />
            </div>

            <div className="flex flex-col items-center justify-center gap-4 text-sm text-gray-500" data-id="element-137">
              <div className="flex items-center gap-2" data-id="element-138">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-139" />
                <span data-id="element-140">Pago 100% Seguro y Encriptado</span>
              </div>
              <p data-id="element-141">Acceso inmediato al PDF tras el pago seguro</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}